import { en, type MessageKey } from './en'

/*
 * Arabic resource — SCAFFOLD. Same key set as en.ts (compiler-enforced).
 *
 * PER PRODUCT-RULES.md §Localisation: do NOT machine-translate the UI; every
 * value needs a translator plus a native reviewer before launch. The nav
 * values below are taken from the V1.9.1 design prototype's RTL demonstration
 * (App Shell.dc.html) — the handoff states they are a layout demonstration,
 * NOT delivered copy. Values still in English are untranslated placeholders.
 * EVERY value in this file is pending native review.
 */
export const ar: Record<MessageKey, string> = {
  // V1.9.1 Phase 2 (Orders + assign flow) — SCAFFOLD ONLY: every key from the
  // English resource is carried through UNTRANSLATED via the spread below.
  // NEEDS-NATIVE-REVIEW: all `orders.*`, `flow.*` and `assign.*` values are
  // English placeholders awaiting a translator + native reviewer (PRODUCT-
  // RULES.md §Localisation — no machine translation). Explicit overrides
  // beneath the spread are the only reviewed-for-layout demo values.
  // NEEDS-NATIVE-REVIEW: the questionnaire type-ahead keys (`quest.search.*`,
  // `quest.multi.hint`, `quest.chip.remove` — settings PR#310) ride the spread
  // below as ENGLISH placeholders awaiting a translator + native reviewer (no
  // machine translation).
  // NEEDS-NATIVE-REVIEW: the questionnaire GUARDIAN-FRAMING keys
  // (`quest.guardian.*` — BOARDROOM-2026-09-05-101707, a parent answering on
  // behalf of a named child) ride the spread below as ENGLISH placeholders
  // awaiting a translator + native reviewer (no machine translation). RTL-safe
  // as plain resource text: neutral punctuation only, no direction-encoding
  // glyphs.
  // NEEDS-NATIVE-REVIEW: the removed-holdings "Recent changes" keys
  // (`orders.empty.none`, `orders.empty.neutral`, `orders.empty.removed`, the
  // shared `recentChanges.*` set — build item #6, BOARDROOM-2026-09-05-121056
  // + review fixes F2/F5) ride the spread below as ENGLISH placeholders
  // awaiting a translator + native reviewer (no machine translation).
  ...en,
  // NEEDS-NATIVE-REVIEW: the child-holder slice's Get-ready card subject
  // label (`getReady.card.forName` — "For {name}") rides the spread above as
  // an ENGLISH placeholder awaiting a translator + native reviewer
  // (PRODUCT-RULES.md §Localisation — no machine translation).
  // NEEDS-NATIVE-REVIEW: the child/teen gender-mismatch block keys
  // (`assign.block.gender.child.*`, `assign.block.gender.teen.*` —
  // BOARDROOM-2026-09-02-053243 finding 3) ride the spread above as ENGLISH
  // placeholders awaiting a translator + native reviewer (PRODUCT-RULES.md
  // §Localisation — no machine translation).
  // NEEDS-NATIVE-REVIEW: the ADD-path missing-gender block keys
  // (`assign.block.genderMissing.child.*`, `assign.block.genderMissing.teen.*`
  // — quality P0 launch-blocker 2026-09-02: blank gender is ineligible on a
  // gender-restricted ticket) ride the spread above as ENGLISH placeholders
  // awaiting a translator + native reviewer (PRODUCT-RULES.md §Localisation —
  // no machine translation).
  // NEEDS-NATIVE-REVIEW: the de-jargoned allocation copy (BOARDROOM-2026-09-
  // 01-193406) — `orders.signin.prompt`, `orders.alloc.loading`,
  // `orders.alloc.unavailable`, `orders.alloc.unconfigured`,
  // `assign.error.service`, `assign.entry.noSeat`, `assign.entry.cantOpen` —
  // rides the spread above as ENGLISH placeholders awaiting a translator +
  // native reviewer (PRODUCT-RULES.md §Localisation — no machine translation).
  // NEEDS-NATIVE-REVIEW: the Orders past-partition keys (`orders.past.title`,
  // `orders.empty.current`, `orders.empty.browse`) and the updated
  // `orders.card.invoice` label ("View invoice") — BOARDROOM-2026-09-01-175306
  // items 2–4 — ride the spread above as ENGLISH placeholders awaiting a
  // translator + native reviewer (no machine translation).
  // NEEDS-NATIVE-REVIEW: the parent-signing visibility keys
  // (`getReady.waiting.*`, `orders.row.subGuestparentClaimed*` — Duncan
  // ruling BOARDROOM-2026-09-02-150714 item 5) ride the spread above as
  // ENGLISH placeholders awaiting a translator + native reviewer
  // (PRODUCT-RULES.md §Localisation — no machine translation).
  // NEEDS-NATIVE-REVIEW: the eligibility-mismatch experience keys
  // (`eligibility.mismatch.*`, `eligibility.support.*`,
  // `getReady.step.profile.mismatch`, `getReady.pill.mismatch` — Duncan
  // rulings BOARDROOM-2026-08-29-120259 + addenda) ride the spread above as
  // ENGLISH placeholders awaiting a translator + native reviewer
  // (PRODUCT-RULES.md §Localisation — no machine translation).
  // NEEDS-NATIVE-REVIEW: the Profile guest-entry SIGNING-STATUS flag keys
  // (`profile.signing.label`, `profile.signing.you`, `profile.signing.parent`,
  // `profile.signing.undetermined` — Duncan ruling BOARDROOM-2026-09-02-150714
  // item 4) ride the spread above as ENGLISH placeholders awaiting a
  // translator + native reviewer (PRODUCT-RULES.md §Localisation — no machine
  // translation). The retired `profile.child.guestClause` key is gone from
  // both resources.
  // NEEDS-NATIVE-REVIEW: the Profile DEFERRED child-grouping keys
  // (`profile.managed.deferredKicker`, `profile.deferred.sentTo`,
  // `profile.deferred.sentToParent` — Duncan ruling BOARDROOM-2026-09-02-
  // 152856 part C, the third "deferred — sent to their parent to sign"
  // grouping) ride the spread above as ENGLISH placeholders awaiting a
  // translator + native reviewer (PRODUCT-RULES.md §Localisation — no machine
  // translation). RTL-safe as plain resource text: no direction-encoding
  // glyphs; the row uses logical `textAlign: 'start'`.
  // NEEDS-NATIVE-REVIEW: the GUARDIAN CLAIM JOURNEY keys (`claim.guardian.*`,
  // `getReady.step.childConfirm.*`, `getReady.step.profile.guardianPending`,
  // `getReady.step.waiver.labelGuardian*`, `getReady.step.waiver.guardianMeta`,
  // `childConfirm.*`, `wizard.step1.intro.selfGuardian` — S2 FE slice,
  // BOARDROOM-2026-09-03-052111 / CMT-2026-09-03-020) and the support
  // compose/confirm interlock keys (`eligibility.support.composed`,
  // `eligibility.support.confirm` — CMT-2026-09-03-021) ride the spread above
  // as ENGLISH placeholders awaiting a translator + native reviewer
  // (PRODUCT-RULES.md §Localisation — no machine translation).
  // NEEDS-NATIVE-REVIEW: the ACCOUNT EDIT HUB keys (`profile.hub.*`,
  // `wizard.loadingProfile` — CMT-2026-09-03-026, the summary-card hub +
  // wizard hydration hold) ride the spread above as ENGLISH placeholders
  // awaiting a translator + native reviewer (PRODUCT-RULES.md §Localisation —
  // no machine translation). RTL-safe: plain resource text, no
  // direction-encoding glyphs (the hub's back chevron is swapped in code).
  // NEEDS-NATIVE-REVIEW: the guardian-checklist who-marker keys
  // (`getReady.step.profile.labelGuardian`, `getReady.step.labelForChild*` —
  // BOARDROOM-2026-09-05-101136) ride the spread above as ENGLISH
  // placeholders awaiting a translator + native reviewer (PRODUCT-RULES.md
  // §Localisation — no machine translation). Translator note: the `{label}`
  // hole composes a full step label with a subject suffix — reorder freely
  // for Arabic word order.
  // NEEDS-NATIVE-REVIEW: the ONE-STEP PARENT SEND keys (`assign.cta.
  // confirmSend`, `assign.replaceBanner`, `assign.done.changeResend` —
  // BOARDROOM-2026-09-05-120305 item 5 + refinement 120713; `assign.cta.
  // sendParent` is retired from both resources) ride the spread above as
  // ENGLISH placeholders awaiting a translator + native reviewer
  // (PRODUCT-RULES.md §Localisation — no machine translation). RTL-safe:
  // plain resource text, neutral punctuation, no direction-encoding glyphs.
  // Bottom tab bar / sidebar nav labels (from the prototype RTL demo)
  'nav.getReady': 'استعد', // NEEDS-NATIVE-REVIEW
  'nav.orders': 'الطلبات', // NEEDS-NATIVE-REVIEW
  'nav.tickets': 'التذاكر', // NEEDS-NATIVE-REVIEW
  'nav.profile': 'حسابي', // NEEDS-NATIVE-REVIEW
  'nav.help': 'المساعدة', // NEEDS-NATIVE-REVIEW

  // Top bar controls — English placeholders, awaiting translation
  'topbar.help.tip': 'Help and contact support', // NEEDS-NATIVE-REVIEW (untranslated placeholder)
  'topbar.lang.tip': 'Language — العربية', // NEEDS-NATIVE-REVIEW (untranslated placeholder)
  // Label on the language toggle = the language it switches TO.
  'topbar.lang.toggleLabel': 'EN', // NEEDS-NATIVE-REVIEW
  'topbar.account.tip': 'Your account', // NEEDS-NATIVE-REVIEW (untranslated placeholder)
  'topbar.account.tipNamed': '{name} — your account', // NEEDS-NATIVE-REVIEW (untranslated placeholder)

  // Get ready (V1.9.1 Phase 1) — English placeholders, awaiting translation
  'getReady.upToDate.title': "You're up to date", // NEEDS-NATIVE-REVIEW (untranslated placeholder)
  'getReady.upToDate.body': 'Nothing for you to do right now.', // NEEDS-NATIVE-REVIEW (untranslated placeholder)
  'getReady.issued.action': 'Issued', // NEEDS-NATIVE-REVIEW (untranslated placeholder)
}
